let flashMessageTimeout = 5000;
window.flashMessageTimeout = flashMessageTimeout;

flashMessage = function(message = '', type = 'success') {
    let alertType = `alert-${type}`;

    $('#flash-type').addClass(alertType);
    $('#flash-message').text(message);
    $('#flash-object').show();

    setTimeout(function() {
        $('#flash-type').removeClass(alertType);
        $('#flash-message').text('');
        $('#flash-object').hide();
    }, flashMessageTimeout);
}
